export default {
  labels: {
    order: 'Bestellung',
    customer: 'Kunde',
  },
  tags: {
    new_customer: 'Neukunde',
    loyal_customer: 'Treuer Kunde',
  },
};
